import Reflux from "reflux";

export default Reflux.createActions([
  "deselectTab",  // Could result in no tabs being activated
  "selectTab",     // Select a tab to activate within the specified tab group
]);
